module.exports = __webpack_public_path__ + "static/media/giovanni-2.7727a05b.wav";